// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3TaXU","options":"AnswerScale_options__ThpmF","selected":"AnswerScale_selected__xreUe"};